import { __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/system';

var QRCodeContainer = styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 8px;\n  background: ", ";\n  /* padding: 6px; */\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 8px;\n  background: ", ";\n  /* padding: 6px; */\n"])), function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral000;
});
var templateObject_1;

export { QRCodeContainer };
